import { AsyncReturnType } from "type-fest";

import { CampaignService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof CampaignService.delete>[0];
type Data = AsyncReturnType<typeof CampaignService.delete>;
type Error = unknown;

export const useDeleteCampaign = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    CampaignService.delete,
    options
  );

  return result;
};
